<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :ignoreMaxTableItemLimit="true" :queryApi="queryApi" :entity="modelName"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPrResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :queryApi="queryApi" :entity="modelName" withCustomRowActions ref="emTable"
                                      :inlineActionsDisabled="prop_inline!=='1'" :ignoreMaxTableItemLimit="true"
                                      :useCustomFieldsDefaultFlag="false"
                                      :custom-form-class="customFormClass"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogDateVisible = true"
                                    >维护需求日期并反馈
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogPriorityVisible = true"
                                    >维护优先级
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogDeliverLocationVisible = true"
                                    >维护交货地点
                                    </b-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="lockPr()"
                                    >锁定
                                    </b-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="unLockPr()"
                                    >解锁
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="需求日期" :visible.sync="dialogDateVisible">
            <el-form>
                <el-form-item label="请输入合适的需求日期:" label-width="auto">
                    <div class="block">
                        <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="prdScheduleDate"
                            type="datetime"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入原因"
                    v-model="remark">
                </el-input>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDateVisible = false">取 消</el-button>
                <el-button type="primary" @click="maintainDate">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="优先级维护" :visible.sync="dialogPriorityVisible">
            <el-form>
                <el-form-item label="请选择优先级">
                    <el-select v-model="priorityValue" placeholder="请选择">
                        <el-option
                            v-for="item in priorities"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogPriorityVisible = false">取 消</el-button>
                <el-button type="primary" @click="maintainPriority">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="交货地点维护" :visible.sync="dialogDeliverLocationVisible">
            <el-form>
                <el-input
                    placeholder="请输入交货地点"
                    v-model="deliverLocation">
                </el-input>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDeliverLocationVisible = false">取 消</el-button>
                <el-button type="primary" @click="maintainDeliverLocation">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import moment from "moment";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";


export default {
    name: "sithMesOpenPrListView",
    components: {MiniButton},
    mixins: [emCommonListMixin, emCommonApiMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            dialogDateVisible: false,
            dialogDeliverLocationVisible: false,
            deliverLocation: '',
            dialogPriorityVisible: false,
            priorityValue: '一般',
            remark: '',
            prdScheduleDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            priorities: [
                {
                    value: '紧急',
                    label: '紧急'
                }, {
                    value: '非常紧急',
                    label: '非常紧急'
                }
            ],
            queryApi: 'findOpenByFilter',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return 'sithMesStoolPr'
        },
        isFixedVendor() {
            return this.$store.state[this.modelName].entity.fixedVendor;
        },
        $_rowMaterialKey() {
            return 'material';
        }
    },
    methods: {
        maintainDate() {
            this.dialogDateVisible = false;
            let ids = this.$store.state[this.modelName].checkedItems;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/maintainDate?prdScheduleDate=" + this.prdScheduleDate;
            this.$_emApiMixin_post(url, {'idList': ids, 'remark': this.remark}).then(response => {
                commonViewsUtil.showSuccess(this, "修改完成！");
                this.$refs.emListFilter.doQuery();
            });

            //通知供应商
            //var url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/sendNotificationToVendors";
            //this.$_emApiMixin_post(url, row);
        },
        maintainDeliverLocation() {
            this.dialogDeliverLocationVisible = false;
            let ids = this.$store.state[this.modelName].checkedItems;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/maintainDeliverLocation";
            this.$_emApiMixin_post(url, {'idList': ids, 'remark': this.deliverLocation}).then(response => {
                commonViewsUtil.showSuccess(this, "修改完成！");
                this.$refs.emListFilter.doQuery();
            });

            //通知供应商
            //var url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/sendNotificationToVendors";
            //this.$_emApiMixin_post(url, row);
        },
        maintainPriority() {
            this.dialogPriorityVisible = false;
            let ids = this.$store.state[this.modelName].checkedItems;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/maintainPriority?priority=" + this.priorityValue;
            this.$_emApiMixin_post(url, ids).then(response => {
                commonViewsUtil.showSuccess(this, "修改完成！");
                this.$refs.emListFilter.doQuery();
            });
        },
        lockPr() {
            let ids = this.$store.state[this.modelName].checkedItems;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/lockPr";
            this.$_emApiMixin_post(url, ids).then(response => {
                this.$refs.emListFilter.doQuery();
            });
        },
        unLockPr() {
            let ids = this.$store.state[this.modelName].checkedItems;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/unLockPr";
            this.$_emApiMixin_post(url, ids).then(response => {
                this.$refs.emListFilter.doQuery();
            });
        },
        customFormClass: (col, row) => {
            if (col.key === 'prdScheduleDate' && row.hasUnReadRequireDateChangeHistory === true
                || col.key === 'prNumber' && row.problemFlag
                || col.key === 'category' && row.category && !row.deliverLocation
                || col.key === 'priority' && row.priority && row.priority.indexOf('紧急') > -1
                || col.key === 'supportStatus' && row.supportStatus === 0) {
                return 'bg-danger text-white';
            }
            return '';
        },

    },
    mounted() {
        let id = this.$route.params.prId;
        if (id) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', id);
        }
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
